import Download from '@/assets/icons/download.svg?component';
import { Button } from '@/components/atoms/Buttons';
import { Spinner } from '@/components/atoms/Spinner';
import { SvgIcon } from '@/components/atoms/SvgIcon/SvgIcon';
import type { ExportColumnDefinition } from '@/components/molecules/ExportDataDropDown/DownloadOptions';
import { type ExtraExportSheet, useDownloadCSVXLSX } from '@/hooks/download-CSV-XLSX';

interface DownloadCsvXlsxProps {
    label: string;
    data: unknown[];
    nameToInclude?: string;
    COLUMNS?: ExportColumnDefinition[];
    variant?: 'primary' | 'secondary' | 'danger' | 'table';
    buttonSize?: 'small' | 'medium' | 'large';
    sheetName?: string;
    extraSheet?: ExtraExportSheet;
}

function DownloadCsvXlsx({
    label,
    data,
    variant = 'secondary',
    nameToInclude = undefined,
    COLUMNS = [],
    buttonSize = 'medium',
    sheetName,
    extraSheet,
}: DownloadCsvXlsxProps) {
    const { loadingCSV, loadingXLSX, downloadCSV, downloadXLSX } = useDownloadCSVXLSX({
        data,
        nameToInclude,
        COLUMNS,
        sheetName,
        extraSheet,
    });
    /* { label, data } */
    if (label === 'CSV') {
        return (
            <Button
                size={buttonSize}
                variant={variant}
                trackingId="export_csv"
                onClick={() => downloadCSV()}
                icon={
                    loadingCSV ? (
                        <Spinner />
                    ) : (
                        <SvgIcon icon={Download} size="custom" customSize={20} />
                    )
                }>
                {label}
            </Button>
        );
    }
    return (
        <Button
            size={buttonSize}
            variant={variant}
            onClick={() => downloadXLSX()}
            trackingId="export_xlsx"
            icon={
                loadingXLSX ? (
                    <Spinner />
                ) : (
                    <SvgIcon icon={Download} size="custom" customSize={20} />
                )
            }>
            {label}
        </Button>
    );
}

export default DownloadCsvXlsx;
export { DownloadCsvXlsx };
